import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchRTPWithdrawTransaction from '../../../../hooks/useApi/useFetchRTPWithdrawTransaction';
import RTPWithdrawalInfo from './RTPWithdrawalInfo';

type TransactionProps = {
  TransactionID: string;
  Notes: string;
};
type FC = FunctionComponent<TransactionProps>;

const RTPWithdrawalContainer: FC = (props: TransactionProps) => {
  const { TransactionID, Notes } = props;
  const [RTPWithdrawTransaction, getRTPWithdrawTransaction] = useFetchRTPWithdrawTransaction({ bearer: '' });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.RTPWithdrawTransactionResponse>();

  useEffect(() => {
    getRTPWithdrawTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (RTPWithdrawTransaction && RTPWithdrawTransaction.Success) {
      setTransaction(RTPWithdrawTransaction);
    }
  }, [RTPWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <RTPWithdrawalInfo transaction={transaction} Notes={Notes} />}</div>;
};

export default RTPWithdrawalContainer;
